// extracted by mini-css-extract-plugin
module.exports = {"theme":"#fec132","themeBg":"#f7f7f7"};